// removed by extract-text-webpack-plugin
module.exports = {"Main":"Block__Main__1_zhv","Content":"Block__Content__eBmkZ","Title":"Block__Title__1rIVA","Text":"Block__Text__33zHX","Skills":"Block__Skills__2b2T1","Flex50":"Block__Flex50__2om0y","Image":"Block__Image__2msNo","SwitchColor":"Block__SwitchColor__lIShm"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/BlockContent/Services/Block.css
// module id = 366
// module chunks = 0